/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AnsweredCommentContainer_story = {
    readonly url: string;
    readonly " $fragmentRefs": FragmentRefs<"UserTagsContainer_story" | "CommentContainer_story">;
    readonly " $refType": "AnsweredCommentContainer_story";
};
export type AnsweredCommentContainer_story$data = AnsweredCommentContainer_story;
export type AnsweredCommentContainer_story$key = {
    readonly " $data"?: AnsweredCommentContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"AnsweredCommentContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnsweredCommentContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserTagsContainer_story"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '9fadd83a2a906b6af4a6ad34603d2639';
export default node;
